module.exports = __webpack_public_path__ + "profile.0e9494e003b882b0e729fb2c25111aaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/profile.svg
// module id = 330
// module chunks = 0